import { GRAY_COLORS } from 'asterX-UI'

export default function CustomLabelX(props) {
  const { x, y, width } = props.viewBox

  return (
    <text
      x={x + width / 2}
      y={y + 45}
      textAnchor="middle"
      fill={GRAY_COLORS[700]}
      fontSize={14}
    >
      {props.value}
    </text>
  )
}
